export default {"src":"/_next/static/media/info-circle-fill.f3170364.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};